import { useStore as useProductStore } from '@/stores/v2/product';
import { TextShape } from '@/web-components/import-wizard/typings/pintura';

export function positionText(
  shape: TextShape,
  positionId: string,
  repositionText: boolean
): { x: number; y: number; w: number; h: number } {
  const artworkSpaceConsumed = 0.97;
  let calcWidth = 0;
  let calcHeight = 0;

  const productStore = useProductStore();

  const currentPrintPosition = productStore.printPositions?.find((p) => {
    return p.id === positionId;
  });

  if (currentPrintPosition) {
    let areaWidth = 0;
    let areaHeight = 0;
    let areaRect = {
      x: 0,
      y: 0,
      w: 0,
      h: 0,
    };

    const area = productStore.printPositionArea(positionId, true);

    if (area && area.kind === 'Rectangle') {
      areaRect = {
        x: area.x,
        y: area.y,
        w: area.width,
        h: area.height,
      };

      areaHeight = areaRect.h;

      areaWidth = areaRect.w;
    } else if (area && area.kind === 'Ellipse') {
      areaRect = {
        x: area.x,
        y: area.y,
        w: area.rx * 2,
        h: area.ry * 2,
      };

      areaHeight = areaRect.h;

      areaWidth = areaRect.w;
    } else if (area && area.kind === 'Polygon') {
      const minX = Math.min(...area.points.map((o) => o.x));
      const minY = Math.min(...area.points.map((o) => o.y));
      const maxX = Math.max(...area.points.map((o) => o.x));
      const maxY = Math.max(...area.points.map((o) => o.y));
      areaRect = {
        x: minX,
        y: minY,
        w: maxX - minX,
        h: maxY - minY,
      };

      areaHeight = areaRect.h;
      areaWidth = areaRect.w;
    }

    calcWidth =
      (shape.originalWidthMM / currentPrintPosition.printArea.widthMm) *
      artworkSpaceConsumed *
      areaWidth;
    calcHeight =
      (shape.originalHeightMM / currentPrintPosition.printArea.heightMm) *
      artworkSpaceConsumed *
      areaHeight;

    const gapW = areaRect.w - calcWidth;
    const gapH = areaRect.h - calcHeight;

    if (repositionText) {
      shape.y = areaRect.y + gapH / 2;
      shape.x = areaRect.x;

      const rotationInDegrees = currentPrintPosition?.printArea
        .rotation as number;
      shape.rotation = (rotationInDegrees * Math.PI) / 180;
    }

    shape.width = calcWidth;
    shape.height = calcHeight;
  }

  return { x: shape.x, y: shape.y, w: shape.width, h: shape.height };
}
